import React from 'react'
import { ExternalLink, LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './ContactUsPage.module.css';
import { FormattedMessage } from 'react-intl';

export default function ContactUsPage() {

  // const title = intl.formatMessage({ id: 'ContactUsPage.title' });

  return (
    <Page title="Contact Us" scrollingDisabled={false}>
    <LayoutSingleColumn
      mainColumnClassName={css.layoutWrapperMain}
      topbar={<TopbarContainer className={css.topbar} currentPage={'ContactUsPage'} />}
      footer={<FooterContainer />}
    >
    <div className={css.contactUs}>
    <h2><FormattedMessage id="ContactUsPage.Heading"/></h2>
    <h3>
    <FormattedMessage id="ContactUsPage.ForQuery"/>
      <span className={css.contactLink}>
        <a href="mailto:info@likenewonly.com" target="_blank">
        <FormattedMessage id="ContactUsPage.ForQueryContact"/></a>
      </span>
    </h3>

    </div>
   
    </LayoutSingleColumn>
  </Page>
  );
}
